module.exports = __webpack_public_path__ + "media/icons/chess-piece-1938a641.png";